var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVacationApproved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-calendar-check--approve-calendar-check-date-day-month-success",
    clipPath: "url(#clip0_17_752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.57146 4.28571C2.11681 4.28571 1.68077 4.46632 1.35928 4.78781C1.03779 5.1093 0.857178 5.54533 0.857178 5.99999V21.4286C0.857178 21.8832 1.03779 22.3193 1.35928 22.6407C1.68077 22.9622 2.11681 23.1428 2.57146 23.1428H21.4286C21.8833 23.1428 22.3193 22.9622 22.6408 22.6407C22.9623 22.3193 23.1429 21.8832 23.1429 21.4286V5.99999C23.1429 5.54533 22.9623 5.1093 22.6408 4.78781C22.3193 4.46632 21.8833 4.28571 21.4286 4.28571H18",
    stroke: "#4D4AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 0.857117V7.71426",
    stroke: "#4D4AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 0.857117V7.71426",
    stroke: "#4D4AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 4.28571H14.5714",
    stroke: "#4D4AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.85718 15.4285L10.2857 18L16.2857 11.1428",
    stroke: "#4D4AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVacationApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vacation_approved.b42e6b1d484c2d507e8875ff8357fded.svg";